export default __webpack_public_path__ + "static/media/one.57d49d7a.jpeg";